import { defineView } from "eddev/views"
import { Header } from "@components/site/Header"
import { Link } from "eddev/routing"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { Button } from "@components/atoms/Button"
import { Appear } from "@components/motion/Appear"
import { useIntersectionObserver } from "usehooks-ts"

export default defineView("archive-leadership", (props) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
    freezeOnceVisible: true,
  })

  return (
    <div className="w-full" ref={ref}>
      <Header noPattern />
      <div className="relative w-full">
        <div className="content-sized py-10 flex flex-col gap-7">
          <Appear as="h1" className="type-sans-4-xl-semibold" slide>
            Leadership
          </Appear>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-4">
            {props.leaderships?.nodes.map((item, ix) => (
              <Appear key={item.id} active={isIntersecting} activeOnly delay={150 * ix}>
                <Link
                  key={item.id}
                  href={item.uri}
                  className="w-full p-4 md:p-2 bg-slate200 rounded-md grid grid-cols-2 gap-6 md:gap-4 items-end group"
                >
                  <div className="rounded-md w-full aspect-[257/287] overflow-hidden">
                    {item.leadershipHeader?.featuredImage?.mediaItemUrl && (
                      <ResponsiveImage
                        {...item.leadershipHeader.featuredImage}
                        className="w-full h-full"
                        objectFit="cover"
                      />
                    )}
                  </div>
                  <div className="flex flex-col w-full gap-1">
                    <p className="type-serif-xl-regular">{item.title}</p>
                    {item.leadershipHeader?.jobTitle && (
                      <p className="type-mono-sm-regular">{item.leadershipHeader?.jobTitle}</p>
                    )}
                    <div className="w-full md:transition-all md:duration-300 md:h-0 md:overflow-hidden md:group-hover:h-[3em] md:group-focus:h-[3em] pt-2">
                      <Button variant="orange" size="sm">
                        Read Bio
                      </Button>
                    </div>
                  </div>
                </Link>
              </Appear>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
})
